import {
  FilterMode,
  EditionDocumentationWorkflowStateCreateMutationVariables,
  EditionDocumentationWorkflowState_OrderBy,
  EditionDocumentationWorkflowState,
  SortOrder,
  EditionDocumentationWorkflowState_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { fieldByLang } from "../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const editionDocumentationWorkflowStateService = {
  createOne: buildCreateOne(
    (
        editionDocumentationWorkflowStateCreateVariables: EditionDocumentationWorkflowStateCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.editionDocumentationWorkflowStateCreate(
          editionDocumentationWorkflowStateCreateVariables
        );
        return result.editionDocumentationWorkflowStateCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.editionDocumentationWorkflowStateOne({ id });
    return result.editionDocumentationWorkflowStateOne as EditionDocumentationWorkflowState;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    language: string = "es",
    orderBy: EditionDocumentationWorkflowState_OrderBy[] | null = null,
    filter: EditionDocumentationWorkflowState_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: EditionDocumentationWorkflowState_Filter | undefined;
    if (searchValue !== "") {
      where = {
        [fieldByLang("name", language)]: {
          contains: searchValue,
          mode: FilterMode.Insensitive,
        },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.editionDocumentationWorkflowStateListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ [fieldByLang("name", language)]: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.editionDocumentationWorkflowStateListWithOffset
    ) as EditionDocumentationWorkflowState[];
    return { list, orderBy };
  },
};
